/* GLAMRDiP — PDP variant ↔ price sync
 *
 * Wires the radio-button variant pickers on the accessory / colour /
 * liquid PDP sections to the price element + ATC button. These sections
 * use a custom radio markup (NOT Dawn's <variant-selects> web component)
 * so they don't get Dawn's variantChange handling for free.
 *
 * Contract per consuming section:
 *   <section data-gd-accessory-pdp | data-gd-colour-pdp | data-gd-liquid-pdp>
 *     <span data-gd-price>{{ p.price | money_without_trailing_zeros }}</span>
 *     <span data-gd-price-was hidden>...</span>
 *     <form>
 *       <div data-gd-variant-radios>
 *         <input type="radio" name="id" value="{{ v.id }}">
 *         ...
 *       </div>
 *       <button data-gd-atc data-gd-atc-label="Add to cart">...</button>
 *     </form>
 *     <script type="application/json" data-gd-variants>
 *       [ { id, available, price, compare_at_price }, ... ]
 *     </script>
 *   </section>
 *
 * On change: looks up the checked radio's variant in the JSON, updates
 * the price text, shows/hides the strikethrough compare-at, toggles the
 * ATC disabled state + label between "Add to cart" / "Sold out".
 */
(function () {
  'use strict';

  function findRoot(group) {
    return group.closest(
      '[data-gd-accessory-pdp], [data-gd-colour-pdp], [data-gd-liquid-pdp]'
    );
  }

  function parseVariants(root) {
    var dataEl = root && root.querySelector('[data-gd-variants]');
    if (!dataEl) return null;
    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function init(group) {
    if (group.dataset.gdVariantSyncWired === '1') return;
    group.dataset.gdVariantSyncWired = '1';

    var form = group.closest('form');
    var root = findRoot(group);
    if (!form || !root) return;

    var variants = parseVariants(root);
    if (!variants || !variants.length) return;

    var priceEl = root.querySelector('[data-gd-price]');
    var compareEl = root.querySelector('[data-gd-price-was]');
    var atc = form.querySelector('[data-gd-atc]');

    function update() {
      var checked = group.querySelector('input[type="radio"][name="id"]:checked');
      if (!checked) return;
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(checked.value)) {
          v = variants[i];
          break;
        }
      }
      if (!v) return;

      if (priceEl) priceEl.textContent = v.price;

      if (compareEl) {
        if (v.compare_at_price) {
          compareEl.textContent = v.compare_at_price;
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }

      if (atc) {
        var label = atc.dataset.gdAtcLabel || 'Add to cart';
        atc.disabled = !v.available;
        atc.textContent = v.available ? label : 'Sold out';
      }
    }

    group.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[type="radio"][name="id"]')) {
        update();
      }
    });
  }

  function bootstrap() {
    var groups = document.querySelectorAll('[data-gd-variant-radios]');
    for (var i = 0; i < groups.length; i++) init(groups[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
